module.exports = __webpack_public_path__ + "05250279384b77f7bb367d622181b5a5.svg";